import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const VoyahStylishEditor = () => {
  const [form, setForm] = useState({
    topTitleEn: "",
    topTitleAr: "",
    topTitleKu: "",

    topSubtitleEn: "",
    topSubtitleAr: "",
    topSubtitleKu: "",

    bottomTitleEn: "",
    bottomTitleAr: "",
    bottomTitleKu: "",

    bottomDescEn: "",
    bottomDescAr: "",
    bottomDescKu: "",
  });

  const [bigImage, setBigImage] = useState(null);
  const [loading, setLoading] = useState(true);

  // Modal
  const [showModal, setShowModal] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);

  const resolveUrl = (u) =>
    u?.startsWith("http") ? u : `${API_BASE}${u}`;

  // LOAD DATA (3 languages)
  useEffect(() => {
    const load = async () => {
      try {
        const [en, ar, ku] = await Promise.all([
          axios.get(`${API_BASE}/api/VFStylishSection?lang=en`),
          axios.get(`${API_BASE}/api/VFStylishSection?lang=ar`),
          axios.get(`${API_BASE}/api/VFStylishSection?lang=ku`),
        ]);

        setForm({
          topTitleEn: en.data.topTitle,
          topSubtitleEn: en.data.topSubtitle,
          bottomTitleEn: en.data.bottomTitle,
          bottomDescEn: en.data.bottomDesc,

          topTitleAr: ar.data.topTitle,
          topSubtitleAr: ar.data.topSubtitle,
          bottomTitleAr: ar.data.bottomTitle,
          bottomDescAr: ar.data.bottomDesc,

          topTitleKu: ku.data.topTitle,
          topSubtitleKu: ku.data.topSubtitle,
          bottomTitleKu: ku.data.bottomTitle,
          bottomDescKu: ku.data.bottomDesc,
        });

        setBigImage(en.data.bigImage);
        setLoading(false);
      } catch (err) {
        console.error("Failed to load VFStylish:", err);
      }
    };

    load();
  }, []);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  // SAVE TEXT
  const handleSave = async () => {
    const token = localStorage.getItem("token");

    try {
      await axios.put(`${API_BASE}/api/VFStylishSection/1`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert("Stylish section updated successfully!");
    } catch (err) {
      console.error(err);
      alert("Failed to update.");
    }
  };

  // UPLOAD IMAGE
  const handleUploadImage = async () => {
    if (!uploadFile) return alert("Select an image first.");

    const token = localStorage.getItem("token");
    const fd = new FormData();
    fd.append("BigImage", uploadFile);

    try {
      await axios.post(`${API_BASE}/api/VFStylishSection/1/media`, fd, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Image uploaded!");
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert("Upload failed.");
    }
  };

  if (loading) return <p>Loading...</p>;

  const LANGS = ["En", "Ar", "Ku"];

  return (
    <div className="container py-4">
      <h2 className="fw-bold mb-4">Voyah FREE — Stylish Section Editor</h2>

      {/* TEXT INPUTS */}
      <div className="row">
        {LANGS.map((l) => (
          <div className="col-lg-4 col-md-6 mb-4" key={l}>
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body">
                <h5 className="text-primary mb-3">{l} Version</h5>

                {/* Top Title */}
                <label className="form-label">Top Title</label>
                <input
                  className="form-control mb-2"
                  name={`topTitle${l}`}
                  value={form[`topTitle${l}`]}
                  onChange={handleChange}
                />

                {/* Top Subtitle */}
                <label className="form-label">Top Subtitle</label>
                <textarea
                  rows={3}
                  className="form-control mb-2"
                  name={`topSubtitle${l}`}
                  value={form[`topSubtitle${l}`]}
                  onChange={handleChange}
                />

                {/* Bottom Title */}
                <label className="form-label">Bottom Title</label>
                <input
                  className="form-control mb-2"
                  name={`bottomTitle${l}`}
                  value={form[`bottomTitle${l}`]}
                  onChange={handleChange}
                />

                {/* Bottom Description */}
                <label className="form-label">Bottom Description</label>
                <textarea
                  rows={4}
                  className="form-control"
                  name={`bottomDesc${l}`}
                  value={form[`bottomDesc${l}`]}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* SAVE BUTTON */}
      <div className="text-end mb-4">
        <button className="btn btn-primary px-4" onClick={handleSave}>
          Save Changes
        </button>
      </div>

      {/* IMAGE PREVIEW + UPLOAD */}
      <h4 className="fw-bold mb-3">Big Image</h4>

      <div className="card shadow-sm border-0 mb-4">
        <div className="card-body">
          {bigImage ? (
            <img
              src={resolveUrl(bigImage)}
              alt=""
              className="w-100 rounded mb-3"
              style={{ maxHeight: "300px", objectFit: "cover" }}
            />
          ) : (
            <p>No image uploaded.</p>
          )}

          <button
            className="btn btn-primary"
            onClick={() => {
              setUploadFile(null);
              setShowModal(true);
            }}
          >
            Upload / Replace
          </button>
        </div>
      </div>

      {/* MODAL */}
      {showModal && (
        <>
          <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog">
              <div className="modal-content shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Upload Big Image</h5>
                  <button
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  />
                </div>

                <div className="modal-body">
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    onChange={(e) => setUploadFile(e.target.files[0])}
                  />
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn btn-primary"
                    onClick={handleUploadImage}
                  >
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show" />
        </>
      )}
    </div>
  );
};

export default VoyahStylishEditor;
